// extracted by mini-css-extract-plugin
export default {"wrapper":"gv","noPadding":"hv","flavor_wrapper":"iv","flavor_button":"jv","vert":"kv","itemContent":"lv","itemName":"mv","blue":"nv","out_of_stock":"ov","newFlavorBadge":"pv","fullWidth":"qv","flavor_button_selected":"rv","black":"sv","attribute_wrapper":"tv","toggle_wrapper":"uv"};
    if(module.hot) {
      // 1711394576165
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  